import React, { useState, useEffect } from "react";
// Use Forms
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// React Bootstrap
import { Container, Form, Button, Col, Alert } from "react-bootstrap";
// Custom spinner
import { entiendadesOtorgadorasExclaustracion, entiendadesOtorgadorasPermisoAusencia, tipoSituacionesParticularesObj } from "../../../contexto";
import { addYears, dateToString2 } from "../../../utils";

// Eliminamos reeingreso 
const tipoSituacionesParticularesObj2 = { ...tipoSituacionesParticularesObj };
delete tipoSituacionesParticularesObj2.Reingreso


const AddSituacionParticular = ({ situacionesParticulares, submissionHandler, ...props }) => {

  // Validación del formulario
  const [validated] = useState(false);
  // Exportamos las funciones de la librería del hook forms
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    //getValues,
    watch,
  } = useForm({
    defaultValues: {
      startDate: dateToString2(new Date()),
      endDate: situacionesParticulares.type !== "Secularizacion" ? dateToString2(addYears(new Date(), 1)) : null,
    },
  });


  // Para el el form
  const [labelStartDate, setLabelStartDate] = useState();
  const [labelEndDate, setLabelEndDate] = useState();
  const [situacionParticularActiva, setSituacionParticularActiva] = useState(false);
  const [hermanaInactiva, setHermanaInactiva] = useState(false);

  const [tipoSituacionesParticulares, setTipoSituacionesParticulares] = useState(tipoSituacionesParticularesObj2);

  // FORMS Functions

  const onSubmit = (data) => {
    // De esta manera nos aseguramos que mdc la fecha endDate estará a null
    if (data.mdc) {
      data.endDate = null;
    }
    submissionHandler(data);
  };

  // UOF
  useEffect(() => {


    const typeLabelStartDate = () => {
      if (watch("type") === "Secularizacion") {
        return "Fecha de indulto";
      } else if (watch("type") === "Reingreso") {
        return "Fecha de reingreso";
      }
      else if (watch("type") === "PasoInstituto") {
        return "Fecha de transpaso";
      }
      return "Fecha inicio";
    };

    const typeLabelEndDate = () => {
      if (watch("type") === "Secularizacion") {
        setValue("endDate", null)
        return "Fecha de aceptación";
      }
      return "Fecha de término";
    };

    setLabelStartDate(typeLabelStartDate());
    setLabelEndDate(typeLabelEndDate());
  }, [watch("type")]);

  // GESTION DATOS PARA MOSTRAR OPCIONES DISPONIBLES

  const procesarServiciosProvinciales = () => {
    // Obtenemos la última situación particular
    let situacionParticularMasReciente = situacionesParticulares[0];
    // Si existe
    if (situacionParticularMasReciente) {
      // Si es null significa que la hermana sigue hasta que dure la causa
      if (!situacionParticularMasReciente.endDate) {
        setSituacionParticularActiva(true);
        // Si hoy está entre la fecha de inicio y fin, sigue en la situación particular
      } else if (new Date() > new Date(situacionParticularMasReciente.startDate) && new Date() < new Date(situacionParticularMasReciente.endDate)) {
        setSituacionParticularActiva(true);
      }
      // Si la última situación particular fue una de estas 2, la única opción posible es que vuelva a la congregacion
      if (situacionParticularMasReciente.type === "Secularizacion" || situacionParticularMasReciente.type === "PasoInstituto") {
        setTipoSituacionesParticulares({ Reingreso: "Reingreso" });
        setValue("type", "Reingreso");
        setHermanaInactiva(true);
      }
    }
  };

  useEffect(() => {
    procesarServiciosProvinciales();
  }, []);

  return (
    <Container className="my-1 position-relative">
      {situacionParticularActiva && <Alert variant={"warning"}>La hermana ya tiene una situación particular en vigor. Hasta que no termine esta situación particular no puede ser añadida otra.</Alert>}
      {!situacionParticularActiva && hermanaInactiva && (
        <Alert variant={"info"}>La hermana se encuentra actualmente fuera de la congregación, la única situación particular posible es el reingreso de la hermana.</Alert>
      )}
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="rounded p-4">
        <fieldset disabled={situacionParticularActiva}>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="type-situacionParticular">
              <Form.Label>{"Tipo de situación particular "} *</Form.Label>
              <Form.Control
                as="select"
                custom
                name="type"
                isInvalid={errors.type}
                {...register("type", {
                  required: "Este campo es obligatorio",
                })}
              >
                {Object.keys(tipoSituacionesParticulares).map((keySituacion) => (
                  <option key={keySituacion} value={keySituacion}>
                    {tipoSituacionesParticulares[keySituacion]}
                  </option>
                ))}
              </Form.Control>
              <ErrorMessage errors={errors} name="type" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>
          {(watch("type") === "PermisoAusencia" || watch("type") === "Exclaustracion") && (
            <Form.Row>
              <Form.Group as={Col} xs={12} md controlId="mdc-situacionParticular">
                <Form.Check custom id="isCollaborative" label={"MDC (Mientras dure la causa)"} name="mdc" {...register("mdc", {})} />
              </Form.Group>
            </Form.Row>
          )}
          <Form.Row>
            <Form.Group as={Col} xs={12} md controlId="startDate-situacionParticular">
              <Form.Label>{labelStartDate} *</Form.Label>
              <Form.Control
                name="startDate"
                type="date"
                isInvalid={errors?.startDate}
                {...register("startDate", {
                  required: "Este campo es obligatorio",
                })}
                onChange={(e) => {
                  watch("type") !== "Secularizacion" && setValue("endDate", dateToString2(addYears(new Date(e.target.value), 1)));
                }}
              />
              <ErrorMessage errors={errors} name="startDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
            </Form.Group>
          </Form.Row>

          {(watch("type") === "PermisoAusencia" || watch("type") === "Exclaustracion" || watch("type") === "Secularizacion") && !watch("mdc") && (
            <Form.Row>
              <Form.Group as={Col} xs={12} md controlId="endDate-situacionParticular">
                <Form.Label>{labelEndDate}</Form.Label>
                <Form.Control name="endDate" type="date" isInvalid={errors?.startDate} {...register("endDate", {
                  validate: {
                    correctDate: (date) => {
                      if (date) return new Date(date) <= new Date(watch("startDate")) ? "La fecha no debe ser mayor a la fecha de inicio" : true;
                    },
                  },
                })} />
                <ErrorMessage errors={errors} name="endDate" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
              </Form.Group>
            </Form.Row>
          )}
          {(watch("type") === "PermisoAusencia" || watch("type") === "Exclaustracion" || watch("type") === "PasoInstituto") && (
            <Form.Row>
              <Form.Group as={Col} xs={12} md controlId="causa-situacionParticular">
                <Form.Label>{"Causa"} *</Form.Label>
                <Form.Control
                  name="cause"
                  type="text"
                  as={"textarea"}
                  isInvalid={errors?.cause}
                  {...register("cause", {
                    required: "Este campo es obligatorio",
                    maxLength: {
                      value: 300,
                      message: "El máximo de caracteres es 300",
                    },
                  })}
                />
                <ErrorMessage errors={errors} name="cause" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
              </Form.Group>
            </Form.Row>
          )}
          {(watch("type") === "PermisoAusencia" || watch("type") === "Exclaustracion") && (
            <Form.Row>
              <Form.Group as={Col} xs={12} md controlId="otorgado-situacionParticular">
                <Form.Label>{"Otorgado por "} *</Form.Label>
                <Form.Control
                  name="givenBy"
                  as="select"
                  custom
                  isInvalid={errors.type}
                  {...register("givenBy", {
                    required: "Este campo es obligatorio",
                  })}
                >
                  {watch("type") === "PermisoAusencia" &&
                    Object.keys(entiendadesOtorgadorasPermisoAusencia).map((keyEntiedad) => (
                      <option key={keyEntiedad} value={keyEntiedad}>
                        {entiendadesOtorgadorasPermisoAusencia[keyEntiedad]}
                      </option>
                    ))}
                  {watch("type") === "Exclaustracion" &&
                    Object.keys(entiendadesOtorgadorasExclaustracion).map((keyEntiedad) => (
                      <option key={keyEntiedad} value={keyEntiedad}>
                        {entiendadesOtorgadorasExclaustracion[keyEntiedad]}
                      </option>
                    ))}
                </Form.Control>
                <ErrorMessage errors={errors} name="givenBy" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />
              </Form.Group>
            </Form.Row>
          )}
          <Button variant="outline-primary" type="submit" className="my-3 w-100">
            {"Añadir"}
          </Button>
        </fieldset>
      </Form>
    </Container>
  );
};

export default AddSituacionParticular;
